import cx from "classnames";
import { HoverCard } from "common/hovercards/HoverCard";
import { Map } from "immutable";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import styles from "./Day.scss";

class EventsList extends React.PureComponent {
  static propTypes = {
    RowComponent: PropTypes.any.isRequired,
  };

  render() {
    const { events, RowComponent, ...props } = this.props;

    return (
      <Fragment>
        {events.map((e) => (
          <RowComponent key={e.id} event={e} id={e.id} {...props} />
        ))}
      </Fragment>
    );
  }
}

export class Day extends React.PureComponent {
  static propTypes = {
    events: PropTypes.object.isRequired,
    range: PropTypes.instanceOf(moment).isRequired,
    color: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  hideMore = () => {
    this.setState({ showMore: false });
  };

  render() {
    const { events, range, date, color, accessors, ...props } = this.props;
    const { showMore } = this.state;

    const thisDaysEvents = events
      .get(range.format("YYYY-MM-DD"), Map())
      .valueSeq()
      .sortBy((e) => accessors.start(e));

    // If we have more than 3 events, we are going to trim this down to 2, and show a more link
    let eventsToShow = thisDaysEvents;
    if (thisDaysEvents.size > 3) {
      eventsToShow = thisDaysEvents.slice(0, 2);
    }

    const today = new Date();
    const isToday = range.isSame(today, "day");

    return (
      <div className={cx(styles.Day, !range.isSame(date, "month") && styles.grey)}>
        <div className={styles.label}>
          <div
            className={cx(styles.date, isToday && !color && styles.current, color && styles.hasColor)}
            style={{ color: isToday && color && `#${color}` }}
          >
            {range.format(range.date() === 1 ? "MMM D" : "D")}
          </div>
        </div>
        <div className={styles.events}>
          <EventsList shownOn={range} events={eventsToShow} color={color} accessors={accessors} {...props} />
          {eventsToShow !== thisDaysEvents && (
            <div className={styles.rightAlign}>
              <div
                className={styles.showMore}
                ref={(r) => {
                  this._more = r;
                }}
                onClick={() => this.setState({ showMore: true })}
              >
                {thisDaysEvents.size - eventsToShow.size} more
              </div>
            </div>
          )}
          {showMore && (
            <HoverCard
              target={this._more}
              arrow
              showOnMount
              theme="blueHeader"
              tippyOptions={{ trigger: "click", placement: "top-end" }}
              onHidden={this.hideMore}
            >
              <div className={styles.EventsPopover}>
                <div className={styles.header}>{range.format("MMM D YYYY")}</div>
                <div className={styles.eventsList}>
                  <EventsList
                    events={thisDaysEvents}
                    showHoverCard={false}
                    shownOn={range}
                    color={color}
                    accessors={accessors}
                    {...props}
                  />
                </div>
              </div>
            </HoverCard>
          )}
        </div>
      </div>
    );
  }
}
